// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3S5sk","delete":"styles_delete__1bhk5","update":"styles_update__1dZem","add":"styles_add__wyEI5"};